export default function applyBranchFilters(list, filter) {
  const finalList = list.map((branch) => {
    let hide = false;

    if (!hide && filter.branch?.trim()) {
      const search = filter.branch.toLowerCase();
      const name = branch.name?.toLowerCase() || "";
      const phone = branch.phone?.toLowerCase() || "";
      if (!name.includes(search) && !phone.includes(search)) hide = true;
    }

    const active = branch.orders?.length > 0;

    if (!hide) {
      if (!filter.activeBranch && active) hide = true;
      if (!filter.inactiveBranch && !active) hide = true;
    }

    return { ...branch, hide };
  });

  return {
    finalList,
    counts: {
      activeBranch: finalList.filter(
        (b) => !b.hide && b.orders && b.orders.length > 0
      ).length,
      inactiveBranch: finalList.filter(
        (b) => !b.hide && (!b.orders || b.orders.length === 0)
      ).length,
    },
  };
}
